import type { ResourceScope } from "./agentExecutionContract";

export interface ResourceLease {
  readonly workItemId: string;
  readonly scope: ResourceScope;
}

function overlap(a: readonly string[], b: readonly string[]) {
  const set = new Set(a);

  return b.some((value) => set.has(value));
}

function conflicts(a: ResourceScope, b: ResourceScope) {
  return (
    overlap(a.paths, b.paths) ||
    overlap(a.services, b.services) ||
    overlap(a.integrations, b.integrations)
  );
}

export class ResourceLockManager {
  private readonly leases = new Map<string, ResourceLease>();

  acquire(workItemId: string, scope: ResourceScope) {
    for (const lease of this.leases.values()) {
      if (conflicts(scope, lease.scope)) {
        throw new Error(
          `Resource conflict between ${workItemId} and ${lease.workItemId}.`,
        );
      }
    }

    this.leases.set(workItemId, {
      workItemId,
      scope,
    });
  }

  release(workItemId: string) {
    this.leases.delete(workItemId);
  }

  snapshot() {
    return [...this.leases.values()];
  }
}
